import useStore from '../../../store';
import { LandlordBooking, TenantBooking } from '../../../types/bookings';
import BookingLandlordRespondInformation from './BookingLanlordRespondToReservation/BookingLanlordRespondToReservation';
import BookingTenantRespondInformation from './bookingTenantRespondToReservation/bookingTenantRespondToReservation';

interface IBookingRespondToResevervation {
  booking: LandlordBooking | TenantBooking;
}

const BookingRespondToReservation = ({
  booking,
}: IBookingRespondToResevervation) => {
  const { user } = useStore(state => ({
    user: state.user,
  }));

  if (user?.type === 'landlord') {
    <BookingLandlordRespondInformation booking={booking as LandlordBooking} />;
  }

  if (user?.type === 'tenant') {
    <BookingTenantRespondInformation booking={booking as TenantBooking} />;
  }

  return null;
};

export default BookingRespondToReservation;
